import { Input, InputFileWrapper, FilePlaceholder } from "@/lib/styles";
import { useState } from "react";
import { SVGPlus } from "@/lib/svg";

export default function InputFile(props: any) {
  const { _key, placeholder = "", name = "", required = false } = props;
  const [fileName, setfileName] = useState(null);

  const getFileName = (e: any) => {
    const target = e.target;
    setfileName(target.files[0].name);
  };

  return (
    <InputFileWrapper
      key={_key}
      isFull={true}
      onFocus={(e) => e.target.classList.remove("error")}
    >
      <label htmlFor={name}>
        {fileName ? fileName : <FilePlaceholder>{placeholder}</FilePlaceholder>}
        <Input
          onChange={(e) => getFileName(e)}
          type="file"
          id={name}
          title={`${placeholder}${required ? "*" : ""}`}
          name={name}
          required={required}
        ></Input>
        <SVGPlus />
      </label>
    </InputFileWrapper>
  );
}
